import { ServiceAppService } from './../../../../security/service-app.service';
import { FileUpload } from './../../../../shared/fileupload/fileupload';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { Table } from 'primeng/table';
import { ExportExcelService } from './../../../../shared/excel-service/export-excel.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-cadastrar-tipo-os-lista',
  templateUrl: './cadastrar-tipo-os-lista.component.html',
  styleUrls: ['./cadastrar-tipo-os-lista.component.scss']
})

export class CadastrarTipoOsListaComponent implements OnInit {

  cols: any[];
  first = 0;
  rows = 10;
  edit = false;
  dados: any[];
  _selectedColumns: any[];
  dado: any;
  isCollapsed = true;
  loading: boolean;
  dadosDialog: boolean;
  submitted: boolean;
  descricaoTipoOs = [];
  tipoOsSelecionar = [];
  selectedCategoriaItem = false;
  displayImport: boolean = false;
  displayFiltros: boolean = false;
  totalPercent = 0;
  progressBarPerc: any;
  nomeModulo: any;
  percentDone: number;
  progress = false;
  paginaAtual: any = 1;
  tamanhoPagina: any = 10;
  totalRegistros: any = 0;
  displayRows: number = 0;
  excelDados: any;
  filtros = {
    descricao: null,
    tipo: null
  }

  tiposMarca: any[] = [];
  selectMarca: any = null;
  selectedDados: any[] = [];
  @ViewChild('dt') dt: Table;
  @ViewChild('fileUploader') fileUpload: FileUpload;

  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private service: ServiceAppService,
    private exportExcel: ExportExcelService,
    private config: PrimeNGConfig) {
    this.nomeModulo = 'cadastrar-tipo-os';
  }

  ngOnInit(): void {
    this.filtrosTratados();
    this.retornaDados();
    this.buscaMarca();
    this.progressBarPerc = 0;

    this.cols = [
      { field: 'descricao', header: 'Descrição' },
      { field: 'tipo', header: 'Tipo' },
      { field: 'edit', header: 'Ações', width: '50px' }
    ];

    this.config.setTranslation({
      "startsWith": "Começa com",
      "contains": "Contém",
      "notContains": "Não Contém",
      "endsWith": "Termina com",
      "equals": "Igual",
      "notEquals": "Não é igual",
      "noFilter": "Sem Filtro",
      "lt": "Menor que",
      "lte": "Menos que ou igual a",
      "gt": "Maior que",
      "gte": "Mais que ou igual a",
      "dateIs": "Data é",
      "dateIsNot": "Data não é",
      "dateBefore": "Data é anterior a",
      "dateAfter": "Data é posterior a",
      "addRule": "Adicionar Regra",
      "removeRule": "Remover Regra",
      "apply": "Aplicar",
      "clear": "Limpar",
      "matchAll": "Combinar tudo",
      "matchAny": "Combinar com qualquer"
    });

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  onPageChange(event: any): void {
    this.paginaAtual = event.page + 1;
    this.tamanhoPagina = event.rows;
    this.displayRows = event.first;
    this.first = event.first;
    this.retornaDados();
  }

  filtrosTratados(event?) {
    this.loading = true;
    this.service.getGeneric('/cadastrar_tipo_os', undefined, undefined, null, null).subscribe(res => {
      if (res.length > 0) {
        this.excelDados = res;
        this.descricaoTipoOs = [];
        this.tipoOsSelecionar = [];
        res.forEach(usuario => {
          if (this.descricaoTipoOs.findIndex(val => val.value == usuario.descricao) < 0) {
            this.descricaoTipoOs.push({ label: usuario.descricao, value: usuario.descricao });
          }

          if (this.tipoOsSelecionar.findIndex(val => val.value == usuario.tipo) < 0) {
            this.tipoOsSelecionar.push({ label: usuario.tipo, value: usuario.tipo });
          }
        });
      }
      this.loading = false;
    });
  }

  retornaDados(event?) {
    this.loading = true;
    this.service.getGeneric('/cadastrar_tipo_os', this.paginaAtual, this.tamanhoPagina, this.filtros.descricao, this.filtros.tipo).subscribe(res => {
      this.dados = res;
      if (res.length > 0) {
        this.totalRegistros = res[0].totalRegistros;
        this.filtrosTratados();
      } else {
        this.totalRegistros = 0;
      }
      this.loading = false;
    });
  }

  recarregaDados() {
    this.dt.first = 0;

    this.retornaDados();
  }

  showDialog() {
    this.displayImport = true;
  }

  onSelectFile(event, uploader: FileUpload) {

    if (event && event.files) {
      this.totalPercent = event.files.length * 100;
      this.percentDone = 0;
      let i = 1;

      this.percentDone = i * 100;
      this.progressBarPerc = Math.round(this.percentDone / this.totalPercent * 100)
      i++;
    } else if (event == null && event.files == null) {
      this.progressBarPerc = 0;
    }
  }

  onUpload(event, fileUploader: any) {
    this.progress = true;
    const file = event.files[0];
    const formData = new FormData();

    formData.append("file", file);

    if (event.files[0].name) {
      this.messageService.add({ key: 'tipoItem', severity: 'info', summary: 'Importando...', detail: 'Aguarde o termino da importação, pode fechar a tela e voltar mais tarde!', life: 7000 });
    }

    this.service.postArquivo('/cadastrar_tipo_os/upload', formData)
      .subscribe(dados => {
        this.messageService.add({ key: 'tipoItem', severity: 'success', summary: 'Sucesso', detail: 'Arquivo enviado com sucesso!', life: 7000 });
        this.progress = false;
        fileUploader.clear();
        this.retornaDados();
      }, (error) => {
        console.log(error, 'errro')
        this.messageService.add({ key: 'tipoItem', severity: 'error', summary: 'Error', detail: error.error.erro, life: 7000 });
        this.progress = false;
      });
  }


  exportarExcel() {
    this.filtrosTratados();
    const dadosTratados = this.tratarDados(this.excelDados);
    const worksheet = XLSX.utils.json_to_sheet(dadosTratados);
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    this.saveAsExcelFile(workbook, this.nomeModulo);
  }

  private tratarDados(dados: any[]): any[] {
    const colunasDesejadas = ['descricao', 'tipo'];
    return dados.map(dado => {
      let novoDado = {};
      colunasDesejadas.forEach(coluna => {
        if (dado.hasOwnProperty(coluna)) {
          novoDado[coluna] = dado[coluna];
        }
      });
      return novoDado;
    });
  }

  private saveAsExcelFile(workbook: any, fileName: string): void {
    XLSX.writeFile(workbook, `${fileName}_export_${new Date().getTime()}.xlsx`);
  }


  progressReport(event) {
    this.fileUpload.progress = event;
  }

  onRemoveFile(event?) {
    this.progressBarPerc = 0;
  }

  removeFile(file: File, uploader: FileUpload) {
    const index = uploader.files.indexOf(file);
    uploader.remove(null, index);
  }

  processarArquivo(dado) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja processar o arquivo?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      key: 'importacaoArquivoHonda',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        const formData = new FormData();

        formData.append("id", dado.id.toString());

        this.dados.forEach(dados => {
          if (dados.id == dado.id) {
            dados.status = 2;
          }
        });
      }
    });
  }

  downloadModelo() {
    const link = document.createElement('a');
    link.href = 'assets/modelos/modelo-cadastrar-tipo-os.xlsx';
    link.download = 'modelo-cadastrar-tipo-os.xlsx';
    link.click();
  }

  showFiltrosAvancados() {
    this.displayFiltros = true;
  }

  hideFiltrosAvancados() {
    this.displayFiltros = false;
  }

  filtrosAPI() {
    this.paginaAtual = 1;
    this.tamanhoPagina = 10;
    this.retornaDados();
  }

  limpafiltros(event) {
    this.filtros = {
      descricao: null,
      tipo: ''
    }

    this.dt.filter('', 'descricao', 'equals');
    this.dt.filter('', 'tipo', 'equals');

    this.retornaDados();
  }

  saveDados() {
    this.submitted = true;

    // Verifica se campo(s) estão preenchidos
    if (typeof this.dado.tipo === "undefined") {
      this.messageService.add({ key: 'tipo', severity: 'error', summary: 'Erro', detail: 'Dados não preenchidos', life: 3000 });
      return;
    }

    // Verifica se for inserção ou alteracão
    if (this.edit) {
      this.service.putDados('/cadastrar_tipo_os', {
        "descricao": this.dado.descricao,
        "tipo": this.dado.tipo,
        "marca": this.selectMarca,
        "id": this.dado.id
      }).subscribe(res => {
        this.retornaDados();
        this.messageService.add({ key: 'myKey1', severity: 'success', detail: "Dados editados com sucesso.", life: 4000 });
      }, (error) => {
        const resultado = error.error.erro;
        this.messageService.add({ key: 'myKey1', severity: 'error', summary: 'Error', detail: resultado, life: 5000 });
      });
      this.edit = false;
      this.dadosDialog = false;
    } else {
      this.service.postDados('/cadastrar_tipo_os/fabrica', {
        "descricao": this.dado.descricao,
        "tipo": this.dado.tipo,
        "marca": this.selectMarca
      }).subscribe(res => {
        this.retornaDados();
        this.messageService.add({ key: 'myKey1', severity: 'success', detail: "Dados cadastrado com sucesso.", life: 4000 });
      }, (error) => {
        const resultado = error.error.erro;
        this.messageService.add({ key: 'myKey1', severity: 'error', summary: 'Error', detail: resultado, life: 5000 });
      })
      this.edit = false;
      this.dadosDialog = false;
    }
  }

  editDados(dado) {
    this.edit = true;
    this.dado = { ...dado };
    this.dadosDialog = true;
    this.selectedCategoriaItem = true;
    // this.tipoSelecionar;
    this.selectMarca = dado.idMarca;
  }

  insertDados(dado) {
    this.edit = false;
    this.dado = { ...dado };
    this.dadosDialog = true;
    this.selectedCategoriaItem = true;
    this.selectMarca = null;
  }

  buscaMarca() {
    this.service.getDados('/cadastrar_tipo_os/marca').subscribe(res => {
      this.tiposMarca = [];
      res.forEach(element => {
        this.tiposMarca.push({ label: element.descricao, value: element.idMarca });
      });
    });
  }

  deleteUnique(event: any) {
    this.deleteDados(event.id)
  }

  deleteMultiplo() {
    this.selectedDados.forEach(element => {
      this.deleteDados(element.id)
    })
  }

  deleteDados(dado: any) {
    this.service.exclusao(`/cadastrar_tipo_os/delete?id=${dado}`).subscribe(res => {
      this.recarregaDados()
      this.messageService.add({ key: 'myKey1', severity: 'success', detail: "Dado excluido com sucesso.", life: 3000 });
    }, (error) => {
      this.messageService.add({ key: 'myKey1', severity: 'warn', detail: error.error.message, life: 5000 });
    });
  }

  //Paginator
  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.dados ? this.first === (this.dados.length - this.rows) : true;
  }

  isFirstPage(): boolean {
    return this.dados ? this.first === 0 : true;
  }

  hideDialog() {
    this.dadosDialog = false;
  }

}